import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconCertificateProps {
  valid: boolean;
}

export const ListStateIconCertificate = (
    props: ListStateIconCertificateProps
) => (
    <ListStateIcon
        tooltip={
            props.valid
                ? Translations.QualificationIsValid
                : Translations.QualificationIsInvalid
        }
        color={props.valid ? "success" : "error"}
        icon={WorkspacePremiumIcon}
    />
);
